const Dashboard = () => import('@/components/dashboard/Dashboard.vue');
const DashboardHome = () => import('@/components/dashboard/DashboardHome.vue');
const DashboardQuotes = () => import('@/components/dashboard/DashboardQuotes.vue');
const DashboardBookings = () => import('@/components/dashboard/DashboardBookings.vue');
//const DashboardRewards = () => import('@/components/dashboard/DashboardRewards.vue');
const DashboardNotifications = () => import('@/components/dashboard/DashboardNotifications.vue');
const DashboardAccount = () => import('@/components/dashboard/account/DashboardAccount.vue');
const DashboardPreferences = () => import('@/components/dashboard/DashboardPreferences.vue');
const DashboardAgents = () => import('@/components/dashboard/agents/DashboardAgents.vue');
const DashboardRequests = () => import('@/components/dashboard/requests/DashboardRequests.vue');
const DashboardQuote = () => import('@/components/dashboard/DashboardQuote.vue');
const DashboardBooking = () => import('@/components/dashboard/DashboardBooking.vue');
const DashboardHelp = () => import('@/components/dashboard/help/DashboardHelp.vue');
const DashboardHelpGuideContent = () =>
  import('@/components/dashboard/help/DashboardHelpGuideContent.vue');
const DashboardHelpGuide = () => import('@/components/dashboard/help/DashboardHelpGuide.vue');
const DashboardHelpVideos = () => import('@/components/dashboard/videos/DashboardHelpVideos.vue');
const DashboardVideoGettingStarted = () => import('@/components/dashboard/videos/VideoGettingStarted.vue');

const ItineraryBuilderSection = () =>
  import('@/components/dashboard/help/ItineraryBuilderSection.vue');
const DashboardSection = () => import('@/components/dashboard/help/DashboardSection.vue');

const DashboardPayments = () => import('@/components/dashboard/DashboardPayments.vue');

export const dashboardRoutes = [
  {
    path: '/dashboard/',
    component: Dashboard,
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: 'home/',
        name: 'dashboardhome',
        component: DashboardHome,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'quotes/',
        name: 'dashboardquotes',
        component: DashboardQuotes,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'quote/:id',
        name: 'dashboard-quote',
        component: DashboardQuote,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'bookings/',
        name: 'dashboardbookings',
        component: DashboardBookings,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'booking/:booking',
        name: 'dashboardbooking',
        component: DashboardBooking,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'notifications/',
        name: 'dashboardnotifications',
        component: DashboardNotifications,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'account/',
        name: 'dashboardaccount',
        component: DashboardAccount,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'preferences/',
        name: 'dashboardpreferences',
        component: DashboardPreferences,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'agents/',
        name: 'dashboardagents',
        component: DashboardAgents,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'requests/',
        name: 'dashboardrequests',
        component: DashboardRequests,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'help/',
        name: 'dashboardhelp',
        component: DashboardHelp,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'help/guide/',
        name: 'dashboardhelpguide',
        component: DashboardHelpGuide,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        },
        children: [
          {
            path: '',
            component: DashboardHelpGuideContent,
          },
          {
            path: 'itinerary-builder/:section/:child/',
            component: ItineraryBuilderSection,
          },
          {
            path: ':section/:child/',
            component: DashboardSection,
          },
        ],
      },
      {
        path: 'help/videos/',
        name: 'dashboardhelpvideos',
        component: DashboardHelpVideos,
        meta: {
          title: 'ANZCRO | The Australasia Holiday Experts'
        }
      },
      {
        path: 'help/videos/getting-started/',
        name: 'dashboardhelpvideogetstarted',
        component: DashboardVideoGettingStarted,
      },
      {
        path: 'payments/result/',
        name: 'paymentResult',
        component: DashboardPayments
      }
    ],
  },
];
